import {FirebaseTopicModel} from "../../firebase-topic-model";
import {IAddToCampaignUpdateData, IInGameCampaign} from "./add-to-campaign-topic.model.interface";

export class IGCAddToCampaignModel extends FirebaseTopicModel<IAddToCampaignUpdateData, IInGameCampaign[]> {
    getTopicName(): string {
        return `CampaignsNotification/${this.services.user.cid}`
    }

    getTopicLabel(): string {
        return "CampaignsNotification";
    }

    protected _mapRawMessageToPublishMessage(rawMessage: IAddToCampaignUpdateData): IInGameCampaign[] {
        return rawMessage?.Campaigns ?? [];
    }

    protected async _isEnabled(): Promise<boolean> {
        if (!this.services.configuration.servicesConfigs.InGameChallenges.isMagic8BallEnabled) {
            return false;
        }

        return true;
    }
}